import { PageErrorBoundary } from '@/components/error-boundaries/page-error-boundary'
import { UsagePage } from '@/routes/usage/page'

export const Usage = () => (
  <PageErrorBoundary>
    <UsagePage />
  </PageErrorBoundary>
)
